module.exports = __webpack_public_path__ + "static/media/sec.8161091b.svg";